import { useCallback } from 'react';

const useQuickOrderQuantityNavigation = ({
  columnId,
  rowId,
  rowIndex,
  orderedRowIds,
  virtualizedRowScrollRef,
}) => {
  const onKeyDownCapture = useCallback(
    (e) => {
      const quantityCellSelector = '[data-quick-order-quantity-cell="true"]';
      const focusQuantityCellInput = (targetCell) => {
        const targetInput = targetCell?.querySelector('input');

        if (!targetInput || targetInput.disabled) {
          return false;
        }

        targetInput.focus();
        targetInput.select();
        return true;
      };
      const arrowKeyDirection = {
        ArrowDown: 1,
        ArrowLeft: -1,
        ArrowRight: 1,
        ArrowUp: -1,
      }[e.key];

      if (!arrowKeyDirection) {
        return;
      }

      const currentCell = e.currentTarget;
      const isHorizontal = e.key === 'ArrowLeft' || e.key === 'ArrowRight';

      if (
        !isHorizontal &&
        orderedRowIds?.length &&
        typeof rowIndex === 'number'
      ) {
        const targetRowIndex = rowIndex + arrowKeyDirection;

        if (targetRowIndex < 0 || targetRowIndex >= orderedRowIds.length) {
          return;
        }

        const targetRowId = orderedRowIds[targetRowIndex];

        const focusTargetCell = () => {
          const targetCell = document.querySelector(
            `${quantityCellSelector}[data-quick-order-quantity-row-id="${targetRowId}"][data-quick-order-quantity-column-id="${columnId}"]`
          );
          return focusQuantityCellInput(targetCell);
        };

        const scrollApi = virtualizedRowScrollRef?.current;

        if (scrollApi) {
          e.preventDefault();
          scrollApi.scrollToRowIndex(targetRowIndex, { align: 'center' });
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              focusTargetCell();
            });
          });
          return;
        }

        if (focusTargetCell()) {
          e.preventDefault();
        }
        return;
      }

      const currentCellGroup = isHorizontal
        ? currentCell.dataset.quickOrderQuantityRowId
        : currentCell.dataset.quickOrderQuantityColumnId;
      const currentCellGroupKey = isHorizontal
        ? 'quickOrderQuantityRowId'
        : 'quickOrderQuantityColumnId';
      const quantityCells = [
        ...document.querySelectorAll(quantityCellSelector),
      ].filter(
        (cell) => cell.dataset[currentCellGroupKey] === currentCellGroup
      );
      const currentIndex = quantityCells.indexOf(currentCell);

      for (
        let targetIndex = currentIndex + arrowKeyDirection;
        targetIndex >= 0 && targetIndex < quantityCells.length;
        targetIndex += arrowKeyDirection
      ) {
        if (focusQuantityCellInput(quantityCells[targetIndex])) {
          e.preventDefault();
          return;
        }
      }
    },
    [columnId, orderedRowIds, rowIndex, virtualizedRowScrollRef]
  );

  return {
    'data-quick-order-quantity-cell': 'true',
    'data-quick-order-quantity-column-id': columnId,
    'data-quick-order-quantity-row-id': rowId,
    onKeyDownCapture,
  };
};

export default useQuickOrderQuantityNavigation;
